<style src="./style.scss">
</style>

<script lang="ts">
  import Button from "@components/button";
  import Checkbox from "@components/checkbox";

  export let reasons = [];
  export let nextPaymentRemainingDays;
  export let goBack = () => null;
  export let nextStep = () => null;
  export let onReasonChange = () => null;

</script>

<div>
  <h1>Por que você quer cancelar a assinatura?</h1>

  <div class="unsubscribe__reasons">
    {#each reasons as reason, index}
      <div>
        <Checkbox
          label="{reason.label}"
          bind:checked="{reasons[index].checked}"
          id="{reason.id}"
          handleChange="{(value) => onReasonChange(value, index)}" />
      </div>
    {/each}
  </div>

  <div class="unsubscribe__buttons">
    <div>
      <Button title="Manter minha assinatura" onClick="{goBack}" />

        <div>
          <span>
            Você tem <b>{nextPaymentRemainingDays} dias restantes</b> para aproveitar seus benefícios
            no CNA Go até a próxima cobrança.
          </span>
        </div>
    </div>
    <div>
      <Button
        title="Continuar cancelamento"
        type="secondary"
        onClick="{nextStep}" />
      <div>
        <span>
          <a target="_blank" href="https://cnago.app/termos/"
            >Contrato e Termos de uso CNA Go</a>
        </span>
      </div>
    </div>
  </div>
</div>
